(function () {
  'use strict';
  function romeNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Rome' })); }
  function cutoffHour() {
    var el = document.querySelector('[data-cutoff]');
    var h = el ? parseInt(el.getAttribute('data-cutoff'), 10) : 14;
    return isNaN(h) ? 14 : h;
  }
  function isBusinessDay(d) { var g = d.getDay(); return g >= 1 && g <= 5; }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isBusinessDay(r)) n--; }
    return r;
  }
  function shipDate(now, cutoff) {
    var s = new Date(now.getTime());
    s.setHours(0, 0, 0, 0);
    var today = isBusinessDay(now) && now.getHours() < cutoff;
    if (!today) { do { s.setDate(s.getDate() + 1); } while (!isBusinessDay(s)); }
    return { date: s, today: today };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(d, withMonth) {
    var o = { weekday: 'short', day: 'numeric' };
    if (withMonth) o.month = 'long';
    return d.toLocaleDateString('it-IT', o).replace('.', '');
  }
  function each(sel, fn) { document.querySelectorAll(sel).forEach(fn); }

  function tick() {
    var now = romeNow();
    var cutoff = cutoffHour();
    var s = shipDate(now, cutoff);
    var from = addBusinessDays(s.date, 2);
    var to = addBusinessDays(s.date, 3);
    var range = 'tra ' + fmt(from, from.getMonth() !== to.getMonth()) + ' e ' + fmt(to, true);
    var left = '';
    if (s.today) {
      var end = new Date(now.getTime());
      end.setHours(cutoff, 0, 0, 0);
      var sec = Math.max(0, Math.floor((end - now) / 1000));
      left = pad(Math.floor(sec / 3600)) + ':' + pad(Math.floor((sec % 3600) / 60)) + ':' + pad(sec % 60);
    }
    var shipWord = s.today ? 'oggi' : s.date.toLocaleDateString('it-IT', { weekday: 'long' });
    each('[data-vm-countdown]', function (el) { el.textContent = left; });
    each('[data-vm-delivery]', function (el) { el.textContent = range; });
    each('[data-vm-shipday]', function (el) { el.textContent = shipWord; });
    each('[data-vm-cutoff]', function (el) { el.textContent = cutoff + ':00'; });
    each('[data-vm-today]', function (el) { el.hidden = !s.today; });
    each('[data-vm-later]', function (el) { el.hidden = s.today; });
  }

  function rotateTopbar() {
    var slides = document.querySelectorAll('.vm-topbar__slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4500);
  }

  function initSticky() {
    var bar = document.querySelector('.vm-sticky');
    if (!bar) return;
    document.body.classList.add('has-vm-sticky');
    var data = [];
    try { data = JSON.parse(bar.querySelector('[data-vm-variants]').textContent); } catch (e) {}
    var money = new Intl.NumberFormat('it-IT', { style: 'currency', currency: bar.getAttribute('data-currency') || 'EUR' });
    var priceEl = bar.querySelector('[data-vm-price]');
    var oldEl = bar.querySelector('[data-vm-old]');
    var btn = bar.querySelector('.vm-btn');
    var last = null;
    function sync() {
      var v = new URLSearchParams(location.search).get('variant');
      if (v === last) return;
      last = v;
      var hit = null;
      for (var i = 0; i < data.length; i++) { if (String(data[i].id) === String(v)) hit = data[i]; }
      if (!hit) return;
      priceEl.textContent = money.format(hit.price / 100);
      if (hit.compare_at_price && hit.compare_at_price > hit.price) {
        oldEl.textContent = money.format(hit.compare_at_price / 100);
        oldEl.hidden = false;
      } else { oldEl.hidden = true; }
      btn.disabled = !hit.available;
      btn.textContent = hit.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
    }
    setInterval(sync, 500);
    sync();
    btn.addEventListener('click', function () {
      var main = document.querySelector('.buy-buttons-block [ref="addToCartButton"]') ||
        document.querySelector('product-form-component [ref="addToCartButton"]') ||
        document.querySelector('form[action*="/cart/add"] [type="submit"]');
      if (main && !main.disabled) { main.click(); return; }
      var target = document.querySelector('.buy-buttons-block') || document.querySelector('variant-picker');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() { tick(); setInterval(tick, 1000); rotateTopbar(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();